'use client';

import { Container } from '@/components/ui/Container';

export default function RefundPolicyPage() {
  return (
    <Container>
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-3xl font-bold mb-8">Refund Policy</h1>
        <div className="prose prose-slate max-w-none">
          <p className="text-lg mb-6">
            Thank you for your payment at bdnog.org. We value your time and appreciate your engagement. 
            Please read the refund policy carefully before making a payment.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Eligibility for Refund</h2>
          <p>
            All payments are non-refundable. Please review your details carefully before completing the payment. 
            Once a payment is made, it cannot be refunded under any circumstances.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Changes to This Refund Policy</h2>
          <p>
            We reserve the right to update or modify this refund policy at any time. Any changes will take effect 
            immediately upon being posted on our website.
          </p>

          <p className="mt-6">
            By making a payment on our website, you acknowledge that you have read, understood, and agreed to 
            the terms of this refund policy.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Contact Us</h2>
          <p>
            If you have any questions or concerns, please contact our customer service team.
          </p>

          <p className="mt-6 font-medium">
            Thank you for engaging with bdNOG.
          </p>
        </div>
      </div>
    </Container>
  );
}
